export default __webpack_public_path__ + "static/media/DDD-Centre-of-Intelligence-Planning.4059bbb4.png";